<template>
  <div class="php-code-editor-wrap" :style="{ height: height }">
    <textarea ref="textarea" class="php-code-textarea-fallback" />
  </div>
</template>

<script>
import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/cobalt.css';
import 'codemirror/mode/clike/clike';
import 'codemirror/mode/php/php';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/selection/active-line';

export default {
  name: 'PhpCodeEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '420px'
    }
  },
  data() {
    return {
      editor: null
    };
  },
  watch: {
    value(val) {
      if (this.editor && val !== this.editor.getValue()) {
        const cursor = this.editor.getCursor();
        this.editor.setValue(val || '');
        this.editor.setCursor(cursor);
      }
    },
    readOnly(val) {
      if (this.editor) {
        this.editor.setOption('readOnly', val);
      }
    },
    height(val) {
      if (this.editor) {
        this.editor.setSize('100%', val);
        this.$nextTick(() => this.editor.refresh());
      }
    }
  },
  mounted() {
    this.initEditor();
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.toTextArea();
      this.editor = null;
    }
  },
  methods: {
    initEditor() {
      this.editor = CodeMirror.fromTextArea(this.$refs.textarea, {
        mode: 'application/x-httpd-php',
        theme: 'cobalt',
        lineNumbers: true,
        lineWrapping: false,
        indentUnit: 4,
        tabSize: 4,
        indentWithTabs: false,
        matchBrackets: true,
        styleActiveLine: true,
        readOnly: this.readOnly,
        viewportMargin: Infinity
      });
      this.editor.setSize('100%', this.height);
      this.editor.setValue(this.value || '');
      this.editor.on('change', (cm) => {
        const val = cm.getValue();
        this.$emit('input', val);
        this.$emit('change', val);
      });
    },
    refresh() {
      if (!this.editor) {
        return;
      }
      if (this.editor.getValue() !== (this.value || '')) {
        this.editor.setValue(this.value || '');
      }
      this.$nextTick(() => this.editor.refresh());
    },
    remount() {
      this.refresh();
    },
    getValue() {
      return this.editor ? this.editor.getValue() : (this.value || '');
    }
  }
};
</script>

<style scoped>
.php-code-editor-wrap {
  border: 1px solid #2b3a4a;
  border-radius: 4px;
  overflow: hidden;
  background: #002240;
}

.php-code-editor-wrap >>> .CodeMirror {
  height: 100%;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.5;
}

.php-code-textarea-fallback {
  display: none;
}
</style>
